<span
    *ngIf="tourEnabled$ | async"
    nz-tooltip
    nzTooltipTitle="{{ 'common.start-tour' | translate }}"
    nzTooltipPlacement="bottom"
    @fadeAnimation
>
    <div class="a-fx a-fx-center-center wizard tour-wizard" (click)="openTour()">
        <svg class="adspt-icon">
            <use xlink:href="#adspt-wizard"></use>
        </svg>
    </div>
</span>
